/**
 * @fileOverview Cross
 */
import type { FunctionComponent, SVGProps } from 'react';

export type Props = SVGProps<SVGElement>;

export const Cell: FunctionComponent<Props> = (props: Props) => null;

Cell.displayName = 'Cell';
